import { createSelector } from "reselect";

export const makeSelectLoader = createSelector(
  (state) => state.loaderReducer,
  (loaderValue) => loaderValue.isLoading
);
